import React, { Component } from 'react';
import Slider from "./Slider"
import OwlCarousel from 'react-owl-carousel';
import "./Scroller.scss"
import ScrollerItems from "./ScrollerItems"

class Scroller extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: true,
            currSlide: 1,
            items: []
        }
        this.itemNode = this.itemNode.bind(this);
        this.loadItems = this.loadItems.bind(this);
        this.SlideCount = this.SlideCount.bind(this);
        this._onChanged = this._onChanged.bind(this);
        this._onChange = this._onChange.bind(this);
    }
    componentDidMount() {
        fetch(`https://z.ynet.co.il/mShort/content/2017/70years/api/articles/getview`)
            .then(data => data.json())
            .then(data => {
                this.setState({
                    items: data,
                    isLoading: false
                })
                this.loadItems();
            })
            .catch(err => console.error(this.props.url, err.toString()));
    }
    SlideCount(item) {
        var itemsLength = this.state.items.length;
        var currSlide = item;
        if (currSlide >= itemsLength) {
            currSlide = 1;
        }
        this.setState({
            currSlide: currSlide
        })
    }
    itemNode(node, index) {
        let items = this.state.items;
        items.forEach(item => item.node = node);
        items.forEach(item => item.index = index);
        this.setState({
            items: items
        });
    }
    getItems() {
        return this.state.items.map((item, index) => <ScrollerItems
            key={index}
            index={index}
            itemNode={this.itemNode}
            item={item} />
        );
    }
    _onChanged(e) {
        window.setTimeout(() => {
            if (window.document.getElementsByClassName("owl-item active center")[0]) {
                var elActive = window.document.getElementsByClassName("owl-item active center")[0].querySelector(".item").attributes["data-index"].value;
            } else{
                var elActive = window.document.getElementsByClassName("owl-item active")[0].querySelector(".item").attributes["data-index"].value;
            }
            this.setState({
                currSlide: Math.round(parseInt(elActive)+1)
            });
        }, 100);
    }
    _onChange(e) {}

    loadItems() {
        if (this.state.items.length > 0) {
            return (
                <Slider getItems={this.getItems()} _onChanged={this._onChanged} _onChange={this._onChange} />
            )
        }
    }
    render() {
        return (
            <section className="section section-scroller">
                <div className="padding">
                    <div className="loading" style={{ display: (this.state.isLoading ? "block" : "none") }}>
                        <div className="loader" id="loader-1"></div>
                    </div>
                    <div className="items">
                        {this.loadItems()}
                        <div className="controllerTimer">
                            <div className="counter">
                                {(this.state.currSlide == 0 ? 1 : (window.screen.width == 490 ? this.state.currSlide : Math.ceil(this.state.currSlide/2)))} / {(window.screen.width == 490 ? this.state.items.length : Math.ceil(this.state.items.length/2))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


export default Scroller;



// WEBPACK FOOTER //
// ./src/Components/App/Scroller.js